import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from 'react';
import { Link as ChakraLink, Container, Flex, Icon } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { Profile } from './profile';
import { ResolutionLogo } from './resolution-logo';
export const Logo = () => (_jsx(ChakraLink, Object.assign({ as: Link, to: "/" }, { children: _jsx(Icon, Object.assign({ width: "216px", height: "29px", viewBox: "0 0 216 29" }, { children: _jsx(ResolutionLogo, {}) })) })));
const RESRE_DARK_BLUE = '#00263A';
export const ResReHeader = ({ user, onLogout, Accessories, MenuItems, }) => {
    const handleLogout = () => {
        if (onLogout) {
            onLogout({
                logoutParams: {
                    returnTo: window.location.origin,
                },
            });
        }
    };
    return (_jsx(Flex, Object.assign({ alignItems: "center", backgroundColor: RESRE_DARK_BLUE }, { children: _jsxs(Container, Object.assign({ maxW: "98%", paddingY: "3", display: "flex", flexDirection: "row", justifyContent: "space-between" }, { children: [_jsx(Flex, Object.assign({ direction: "row", alignItems: "center" }, { children: _jsx(Logo, {}) })), _jsxs(Flex, Object.assign({ alignItems: "center", gridGap: "6" }, { children: [Children.map(Accessories, (accessory) => accessory), user && onLogout && (_jsx(Profile, { user: user, onLogout: handleLogout, MenuItems: MenuItems }))] }))] })) })));
};
